
import React, { useState, useEffect }  from "react";
import { connect } from "react-redux";
import moment from 'moment';

import MenuItem from '@material-ui/core/MenuItem';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {
  updateloglostitem,
} from '../api/loglostitem.api';
import { getAllitem } from '../api/item.api';



const LoftyloglostitemUpdateModal = ({open, handleClose, successAction, token, doc}) => {
  const [dataLoftyitem, setDataLoftyitem] = useState([]);

  
  useEffect(() => {
    const handleDataLoftyApps = async () => {
      try {
				const resLoftyitem = await getAllitem({ token });
				setDataLoftyitem(resLoftyitem.data);


      } catch (error) {
        // error
      }
    }
    handleDataLoftyApps();
  }, []);
  return (
    <Dialog fullWidth open={open} onClose={handleClose}>
      <DialogTitle>
        Actualizar loglostitem
      </DialogTitle>
      <DialogContent>
        <form
          onSubmit={async e => {
            e.preventDefault();
            try {
              await updateloglostitem({
                token: token,
                _id: doc._id,
                idItem: e.target.idItem.value,
							status: e.target.status.value,
							createdAt: new Date(e.target.createdAt.value),

              });
              if (successAction) {
                successAction();
              }
              alert('Se agrego exitosamente el dato');
            } catch (error) {
              if (error.info) {
                alert(error.info);
              } else {
                alert('Lo sentimos no se logro agregar el dato');
              }
            }
          }}
        >
  				<div className="my-3">
					<TextField name="idItem" label="idItem" defaultValue={doc?.idItem} variant="outlined" fullWidth select>
						{
							dataLoftyitem.map(item => (
								<MenuItem key={item._id} value={item._id}>{item.description}</MenuItem>
							))
						}
					</TextField>
				</div>
				<div className="my-3">
					<TextField type="text" name="status" label="Estatus" variant="outlined" defaultValue={doc?.status} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="date" name="createdAt" label="Fecha de creacion" variant="outlined" defaultValue={doc?.createdAt ? moment(doc?.createdAt).format('YYYY-MM-DD') : ''} fullWidth />
				</div>

          <div className="my-3 text-center">
            <Button type="submit" variant="outlined" color="primary">
              Actualizar
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = state => state.auth;

export default connect(mapStateToProps)(LoftyloglostitemUpdateModal);
